<template>
  <main class="unbind-handling-page">
    <AppNavBar
      :title="t('card.unBindCardText_7')"
      :left-arrow="false"
      :auto-back="false"
      background-color="#ffffff"
    />

    <section class="handling-content">
      <div class="loading-ring">
        <svg
          class="loading-ring__active"
          viewBox="0 0 190 190"
          aria-hidden="true"
        >
          <circle
            cx="95"
            cy="95"
            r="91"
            fill="none"
            stroke="#2667ff"
            stroke-width="8"
            stroke-linecap="round"
            stroke-dasharray="143 429"
            transform="rotate(-135 95 95)"
          />
        </svg>
        <app-image
          src="@/assets/images/cardImage/circle_inside_bg.png"
          alt=""
        />
      </div>
      <div class="handling-title">{{ t("card.unBindCardText_8") }}</div>
      <p>{{ t("card.unBindCardText_9") }}</p>
      <div class="handling-safe">
        <app-image src="@/assets/images/cardImage/protect_icon.png" alt="" />
        <span>{{ t("card.unBindCardText_10") }}</span>
      </div>
    </section>
  </main>
</template>

<script setup>
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { pcCardCancel } from "@/api/card";
import { getRouteState, navigateWithState } from "@/utils/route-state";

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const pageState = getRouteState(route, "card-unbind-handling", {});

const unbindCard = async () => {
  try {
    await pcCardCancel(
      { cardId: pageState.cardId },
      { meta: { showLoading: false } },
    );
    navigateWithState(router, "/card/unbind/result", {
      namespace: "card-unbind-result",
      replace: true,
      payload: { status: "1" },
    });
  } catch (error) {
    navigateWithState(router, "/card/index", {
      namespace: "home-card",
      replace: true,
      payload: {
        leftArrow: true,
        backTo: "/home/card",
      },
    });
  }
};

onMounted(unbindCard);
</script>

<style scoped lang="scss">
.unbind-handling-page {
  min-height: var(--app-viewport-height);
  background: #ffffff;
  position: relative;
}

.handling-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 84px 24px 30px;
  text-align: center;
}

.loading-ring {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 190px;
  height: 190px;
  border: 8px solid #f4f5f6;
  border-radius: 50%;
  animation: unbind-spin 1s linear infinite;

  &__active {
    position: absolute;
    inset: -8px;
    width: calc(100% + 16px);
    height: calc(100% + 16px);
    overflow: visible;
    pointer-events: none;
  }

  .app-image {
    width: 118px;
    height: 118px;
    animation: unbind-spin-reverse 1s linear infinite;
  }
}

.handling-title {
  margin-top: 24px;
  color: #000000;
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
}

.handling-content > p {
  margin: 8px 0 0;
  color: #666666;
  font-size: 14px;
  line-height: 22px;
}

.handling-safe {
  display: flex;
  align-items: center;
  gap: 5px;
  // margin-top: 120px;
  position: absolute;
  bottom: 5%;
  color: #999999;
  font-size: 13px;

  .app-image {
    width: 20px;
    height: 20px;
  }
}

@keyframes unbind-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes unbind-spin-reverse {
  to {
    transform: rotate(-360deg);
  }
}
</style>
